import React from 'react';
import { TransifexManager } from '@vend/react-utilities';
export const BUSINESS_COMPONENTS_TRANSLATION_TAG = 'monocle-business-components';
const withTranslations = (
// eslint-disable-next-line @typescript-eslint/naming-convention
Component, displayName) => {
    const TranslatedComponent = props => {
        return (React.createElement(TransifexManager, { tag: BUSINESS_COMPONENTS_TRANSLATION_TAG },
            React.createElement(Component, Object.assign({}, props))));
    };
    const componentName = 
    // eslint-disable-next-line i18next/no-literal-string
    displayName || Component.displayName || Component.name || 'Component';
    TranslatedComponent.displayName = componentName;
    return TranslatedComponent;
};
/**
 * Equivalent to withTranslations but for components that expose a ref API e.g. via useImperativeHandle
 * or React.forwardRef.
 */
const withTranslationsForwardRef = (
// eslint-disable-next-line @typescript-eslint/naming-convention
Component, displayName) => {
    const TranslatedComponent = React.forwardRef((props, ref) => {
        return (React.createElement(TransifexManager, { tag: BUSINESS_COMPONENTS_TRANSLATION_TAG },
            React.createElement(Component, Object.assign({ ref: ref }, props))));
    });
    const componentName = 
    // eslint-disable-next-line i18next/no-literal-string
    displayName || Component.displayName || Component.name || 'Component';
    TranslatedComponent.displayName = componentName;
    return TranslatedComponent;
};
export { withTranslations, withTranslationsForwardRef };
